import React from "react";
import { Search, RotateCw } from "lucide-react";
import { useT } from "../../../../stores/uiLang";
import { TD_T } from "../../../../i18n/teacherDashboard";

interface StudentProgressFiltersProps {
  searchTerm: string;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectedClass: string;
  onClassChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  classes: Array<{ id: string; name: string }>;
  onRefresh: () => void;
  loading: boolean;
  hasClasses: boolean;
}

export function StudentProgressFilters({
  searchTerm,
  onSearch,
  selectedClass,
  onClassChange,
  classes,
  onRefresh,
  loading,
  hasClasses,
}: StudentProgressFiltersProps) {
  const t = useT(TD_T);
  return (
    <div className="flex items-center">
      <div className="relative mr-4">
        <input
          type="text"
          placeholder={t.searchStudents}
          value={searchTerm}
          onChange={onSearch}
          className="rounded-md border border-gray-300 shadow-sm px-4 py-2 text-sm focus:ring-indigo-500 focus:border-indigo-500 pr-8"
        />
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
          <Search className="h-4 w-4 text-gray-400" />
        </div>
      </div>
      <div className="relative mr-4">
        <select
          value={selectedClass}
          onChange={onClassChange}
          disabled={!hasClasses}
          className="rounded-md border border-gray-300 shadow-sm px-4 py-2 text-sm focus:ring-indigo-500 focus:border-indigo-500 bg-white"
        >
          <option value="all">{t.allClasses}</option>
          {classes.map((classItem) => (
            <option key={classItem.id} value={classItem.id}>
              {classItem.name}
            </option>
          ))}
        </select>
      </div>
      <button
        onClick={onRefresh}
        disabled={loading || !hasClasses}
        className="flex items-center px-2 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
      >
        <RotateCw className={`h-4 w-4 ${loading ? "animate-spin" : ""}`} />
      </button>
    </div>
  );
}
